// Keep the original seed outside the payload while typing changes the plan amount.
const originalInvestmentAmounts = new WeakMap<object, number>();

export function rememberInvestmentAmount(strategy: object, calculatedAmount: number): void {
  originalInvestmentAmounts.set(strategy, calculatedAmount || 0);
}

export function isInvestmentAmountOverridden(calculatedAmount: number, investedAmount: number): boolean {
  return !!calculatedAmount && calculatedAmount !== (investedAmount || 0);
}

export function updateInvestmentOverride(
  strategy: { investmentOverriden?: boolean },
  calculatedAmount: number,
  investedAmount: number
): void {
  if (!originalInvestmentAmounts.has(strategy)) {
    rememberInvestmentAmount(strategy, calculatedAmount);
  }
  strategy.investmentOverriden = isInvestmentAmountOverridden(
    originalInvestmentAmounts.get(strategy), investedAmount
  );
}
